import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem } from "namirasoft-core";
import { NamirasoftERPMetaDatabase, ServiceInputRow, ServiceRow, ServiceTypeRow, VehicleRow } from "namirasoft-erp";
import { NSBox, NSBoxDateTime, NSBoxEntity, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class ServiceEditPage extends Component<Props>
{
    ServiceType = createRef<NSBoxEntity<ServiceTypeRow>>();
    Vehicle = createRef<NSBoxEntity<VehicleRow>>();
    Datetime = createRef<NSBoxDateTime>();
    Description = createRef<NSBoxTextArea>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<ServiceRow, ServiceInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.service(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): ServiceInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        service_type_id: this.ServiceType.current?.getValueOne() ?? "",
                                        vehicle_id: this.Vehicle.current?.getValueOne() ?? "",
                                        datetime: new Date(this.Datetime.current?.getValue() ?? new Date().toISOString()),
                                        description: this.Description.current?.getValue() ?? null,
                                        service_category: [],
                                        service_tag: [],
                                        service_field: [],
                                    }),
                                    setRow: (row: ServiceRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.ServiceType.current?.setValueOne(row.service_type_id);
                                        this.Vehicle.current?.setValueOne(row.vehicle_id);
                                        this.Datetime.current?.setValue(new Date(row.datetime).toISOString());
                                        this.Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<ServiceTypeRow>
                        ref={this.ServiceType} title="Service Type" info={{ link: "https://namirasoft.com/erp/console-guide/service/#field-service-type-id" }} required multiple={false}
                        table_name="service_type" table={db.tables.service_type}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.service_type, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.service_type, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.service_type.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<VehicleRow>
                        ref={this.Vehicle} title="Vehicle" info={{ link: "https://namirasoft.com/erp/console-guide/service/#field-vehicle-id" }} required multiple={false}
                        table_name="vehicle" table={db.tables.vehicle}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.vehicle, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.vehicle, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.vehicle.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxDateTime ref={this.Datetime} required defaultValue={this.props.isEdit ? undefined : new Date()} title="Datetime" info={{ link: "https://namirasoft.com/erp/console-guide/service/#field-datetime" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/service/#field-description" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}